module.exports = "data:image/svg+xml;base64,77u/PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIwIDAgNDggNDgiIGZpbGw9InJnYmEoNjQsIDE1OCwgMjU1LCAxKSI+CiAgICA8cGF0aCBkPSJNMCAwaDQ4djQ4SDB6IiBmaWxsPSJub25lIj48L3BhdGg+CiAgICA8cGF0aCBkPSJNMjggNEgxMkM5Ljc5IDQgOC4wMiA1Ljc5IDguMDIgOEw4IDQwYzAgMi4yMSAxLjc3IDQgMy45OCA0SDM2YzIuMjEgMCA0LTEuNzkgNC00VjE2TDI4IDR6bTQgMzJIMTZ2LTRoMTZ2NHptMC04SDE2di00aDE2djR6bS02LTEwVjdsMTEgMTFIMjZ6Ij48L3BhdGg+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/file.svg
// module id = S5Ji
// module chunks = 30